var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"modal-header\"><h4>Photos</h4></div><div class=\"modal-body\"><div ng-model=\"photos\" oc-photos=\"true\" not-writable=\"true\" prevent-delete=\"true\"></div></div><div class=\"modal-footer\"><button ng-click=\"modalClose()\" class=\"btn btn-warning\">Close</button></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/directives/photos-modal.jade
 ** module id = 775
 ** module chunks = 0 1 3 4 5 6
 **/